import { formatterId } from '../../../helpers/formatters';
import { refFormat } from '../../../helpers/tableFormatters';

const MESES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

// Las fechas circulan por la aplicación como "aaaa-mm-dd", a veces sin ceros a la izquierda.
const splitDate = (value) => {
    if (!value) return {};
    const [anio, mes, dia] = String(value).split('-');
    if (!anio || !mes || !dia) return {};
    return {
        dia: String(dia).padStart(2, '0'),
        mes: MESES[Number(mes) - 1] || mes,
        anio
    };
};

const clientName = (info) => {
    if (!info) return '';
    if (info.razonSocial) return info.nombreComercial || info.razonSocial;
    return [info.nombre1, info.nombre2, info.apellido1, info.apellido2]
        .filter(Boolean)
        .join(' ')
        .trim();
};

const amount = (value) => (value || value === 0 ? formatterId(Number(value)) : '');

const optionName = (options, id) => {
    const found = (options || []).find(item => String(item.id) === String(id));
    return found ? found.nombre : '';
};

// El número de crédito se muestra igual que en el formulario: con prefijo de la
// línea y consecutivo a siete dígitos cuando la numeración es automática.
const creditNumber = (numero, automatico, linea) => {
    if (!numero) return '';
    if (!automatico) return String(numero);
    const prefijo = linea ? linea.prefijo : '';
    const consecutivo = String(numero).padStart(7, '0');
    return prefijo ? `${prefijo}-${consecutivo}` : consecutivo;
};

/**
 * Arma los datos del formato F – CR - 03 a partir de lo capturado en la
 * solicitud. Los campos que solo se conocen al liquidar o desembolsar
 * (N° de liquidación, sección 3, sección 4 y anticipos) se dejan vacíos para
 * diligenciarlos a mano sobre el impreso.
 */
const buildFormatoData = ({
    solicitud,
    client,
    adviser,
    formCreditInfo,
    formCreditData,
    formRefData,
    selectedPagaduria,
    creditLinesOptions,
    creditSublinesOptions,
    cutDate,
    date
}) => {
    const info = client ? client.terceroInformacion : {};
    const ubicacion = client ? client.terceroUbicacion : {};
    const linea = (creditLinesOptions || []).find(
        item => String(item.id) === String(formCreditInfo?.creditLine)
    );
    const pagaduria = (adviser?.asesorPagaduria || []).find(
        item => String(item.idPagaduria) === String(selectedPagaduria)
    );
    const novedad = splitDate(cutDate);

    return {
        // De la respuesta solo se toma el consecutivo de la solicitud: el resto de
        // campos del objeto que devuelve el servicio no vienen poblados.
        numeroCredito: creditNumber(
            formCreditInfo?.creditNumber,
            formCreditInfo?.automatico,
            linea
        ),
        numeroSolicitud: solicitud?.solicitud ? refFormat(solicitud.solicitud) : '',
        numeroLiquidacion: '',
        fecha: splitDate(date),
        cliente: {
            nombre: clientName(info),
            tipoDocumento: info?.tipoIdentificacion || '',
            identificacion: info?.identificacion || '',
            lugarExpedicion: info?.infoMunicipioExp || '',
            direccion: ubicacion?.direccionRes || '',
            ciudad: ubicacion?.infoMunicipioRes || '',
            email: ubicacion?.correo || '',
            celular: ubicacion?.telefono1 || '',
            entidadPagadora: pagaduria ? pagaduria.infoPagaduria : ''
        },
        referencia: {
            nombre: formRefData?.fullName || '',
            identificacion: formRefData?.identificacion || '',
            celular: formRefData?.phone || '',
            email: formRefData?.email || '',
            direccion: formRefData?.address || '',
            ciudad: ''
        },
        credito: {
            montoTransado: amount(formCreditData?.amount),
            cuotas: formCreditData?.term || '',
            linea: linea ? linea.nombre : '',
            subLinea: optionName(creditSublinesOptions, formCreditInfo?.creditSubline),
            tasa: formCreditData?.rate || '',
            valorCuota: amount(formCreditData?.cuota),
            mesNovedad: novedad.mes ? `${novedad.mes} ${novedad.anio}` : '',
            observacion: ''
        }
    };
};

export default buildFormatoData;
